import { maskMonetaryValue } from 'utils/stringUtils';
import { ApplicationProductName } from 'enums/common.enums';
import { MINIMUM_LOAN_AMOUNT } from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/loanInformation.constants';
import { LoanAmountType } from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/LoanAmount/loanAmount.enums';

export const STEP_1_RANGE = 50;
export const STEP_2_RANGE = 50;
export const STEP_3_RANGE = 35;
export const MAXIMUM_STEPS = STEP_1_RANGE + STEP_2_RANGE + STEP_3_RANGE;
export const MAXIMUM_LOAN_AMOUNT_1_RANGE = 50000;
export const MAXIMUM_LOAN_AMOUNT_2_RANGE = 150000;
export const MAXIMUM_LOAN_AMOUNT_RANGE = 500000;
export const MINIMUM_STEP_LOAN_AMOUNT = 1000;
export const MEDIUM_STEP_LOAN_AMOUNT = 2000;
export const MAXIMUM_STEP_LOAN_AMOUNT = 10000;
export const START_FULL_RANGE = 0;
export const LOAN_SLIDER_MARKS = [
  {
    value: START_FULL_RANGE,
    label: maskMonetaryValue(MINIMUM_LOAN_AMOUNT),
  },
  {
    value: STEP_1_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_1_RANGE),
  },
  {
    value: STEP_1_RANGE + STEP_2_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_2_RANGE),
  },
  {
    value: STEP_1_RANGE + STEP_2_RANGE + STEP_3_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_RANGE),
  },
];
export const MIN_HIL_LOAN_AMOUNT_RANGE = 15000;
export const START_HIL_RANGE = 14;
export const HIL_LOAN_SLIDER_MARKS = [
  {
    value: START_HIL_RANGE,
    label: maskMonetaryValue(MIN_HIL_LOAN_AMOUNT_RANGE),
  },
  {
    value: STEP_1_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_1_RANGE),
  },
  {
    value: STEP_1_RANGE + STEP_2_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_2_RANGE),
  },
  {
    value: STEP_1_RANGE + STEP_2_RANGE + STEP_3_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_RANGE),
  },
];

export const MIN_POS_LOAN_AMOUNT_RANGE = 14999;
export const MAX_POS_STEPS = 14;
export const POS_LOAN_SLIDER_MARKS = [
  {
    value: START_FULL_RANGE,
    label: maskMonetaryValue(MINIMUM_LOAN_AMOUNT),
  },
  {
    value: MAX_POS_STEPS,
    label: maskMonetaryValue(MIN_POS_LOAN_AMOUNT_RANGE),
  },
];
export const MAX_HIL_LOAN_AMOUNT_LENGTH = 8;
export const MAX_POS_LOAN_AMOUNT_LENGTH = 7;
export const MAP_PRODUCT_NAME_TO_LOAN_AMOUNT_TYPE = {
  [ApplicationProductName.HomeImprovementLoan]: LoanAmountType.HomeImprovement,
  [ApplicationProductName.SmallLoanProgram]: LoanAmountType.PointOfSale,
  default: LoanAmountType.Full,
};
